// import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Import your custom styles after Bootstrap CSS is loaded
import '../scss/custom.scss';
import './utils/assetExports';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <App />
);